export default "__VITE_ASSET__DpefuZPG__"